import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Keep router navigation; feedback hardening does not assert a routing defect.
export default function GovernedNavigation({ to, children, pendingText = 'Opening Strategic Analysis…' }) {
  const navigate = useNavigate();
  const locked = useRef(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!pending) return undefined;
    const fail = () => { locked.current = false; setPending(false); setError('Navigation did not complete. Please try opening the workspace again.'); };
    const start = setTimeout(() => { try { navigate(to); } catch { fail(); } }, 0);
    const limit = setTimeout(fail, 5000);
    return () => { clearTimeout(start); clearTimeout(limit); };
  }, [pending, navigate, to]);
  return <>
    <Link to={to} aria-disabled={pending} onClick={event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (locked.current) return; // Visible pending feedback already describes the accepted activation.
      locked.current = true; setError(''); setPending(true);
    }}>{children}</Link>
    {pending && <span role="status">{pendingText}</span>}
    {error && <p role="alert">{error}</p>}
  </>;
}
